import * as Logger from './logger';
import axios from 'axios';
import * as OptimizelyHelpers from './optimizelyHelpers';


let capturedEventsPromise: Array<Function> = [];
let onAnalyticsLoad = () => {
  Promise.all(capturedEventsPromise.map(fn => fn()));
};

export const trackEvent = function (event: string, data?: Record<string, any>) {
  // First try to use the atl-global wrapper
  if (typeof ace !== "undefined") {
    ace.analytics.Tracking.trackEvent(event, data);
  } else {
    capturedEventsPromise.push(
      () => new Promise((resolve) => {
        trackEvent(event, data);
        resolve(null);
      })
    );

    window.segmentPageReady = onAnalyticsLoad;

    Logger.log({
      event,
      data,
    }, 'Analytics wrapper track event');
  }
};

export const trackOptimizely = function (name: string) {
  if (typeof window.optimizely !== 'undefined') {
    window.optimizely.push({
      type: 'event',
      eventName: name
    });
  }
};
/**
* Iterates through event keys, ensures that values are lowercase,
* and replaces whitespace with `-` character
**/
export const sanitizeEventProperties = function (propertiesObj) {
  let result = {};
  Object.keys(propertiesObj).map(key => {
    // do a quick check just in case values are null
    result[key] = propertiesObj[key] && propertiesObj[key].replace(/\s+/g, '-').toLowerCase();
  });
  return result;
}

export const trackGas = function (postBody) {
  const analyticsApiUrl = 'https://mgas.prod.public.atl-paas.net/v1/event';
  const options = {
    headers: {
      'content-type': 'application/json'
    },
    withCredentials: true
  };

  postBody['properties']['optimizelyCohorts'] = OptimizelyHelpers.getOptimizelyCohorts();
  postBody['properties']['optimizelySegments'] = OptimizelyHelpers.getOptimizelySegments();
  postBody['properties']['optimizelyEndUserId'] = OptimizelyHelpers.getOptimizelyEndUserId();
  return axios.post(analyticsApiUrl, postBody, options)
    .then(() => Promise.resolve());
};
